module.exports = __webpack_public_path__ + "assets/img/101011.27b54bab.png";